import type { FaireProductEntity } from "../../entity_types/product";

export const p_xzgqsebaec: FaireProductEntity = {
  token: "p_xzgqsebaec",
  type: "product",
  name: "Tea Sachet biodegradable loose leaf tea bags",
  brandToken: "b_cm73zmtk8g",
  brandName: "Sage & Stone Apothecary",
  imageUrl: "https://cdn.faire.com/fastly/639dacac0b84118b434eb0bf4cb14984af7e918f315781c26a9a61c8c4413d4b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cc552f469ea4b5c4b3ed97039c72e64855dd46e2010714ca2d63c2bc6a9796bc.jpeg",
    "https://cdn.faire.com/fastly/6eb5742b46881d0cea4c55e3d54677091c21bf4c23567a5d3890b87fb07e31bd.jpeg",
    "https://cdn.faire.com/fastly/bb205f4f9c2b5384332ed09f821909cd722072738e1dc1b01b58789b8fd7730e.jpeg"
  ],
  priceDollars: 4,
  description: " Pack of 20 biodegradable & unbleached tea bags. Easy, single use bags - just slip the herbs right in, and cinch closed. Drop into your mug, pour over freshly boiled water & allow to steep following brewing instructions. Save for a double steep & compost when finished. These make a great addition to loose leaf tea gifts. ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:56.884Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
